import { EditProfileService } from './edit-profile.service';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { ToastService } from 'src/app/base/services/toast.service';
import { homeRoute } from '../../core/routing/route-names';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Role, UserInfoDTO } from '../models/models.swagger.generated';
import { AuthService } from '../services/auth.service';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserEditFormComponent } from '../user-management/user-edit-form/user-edit-form.component';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';
import { UserEditFormGroup, UserEditFormType } from '../user-management/user-edit-form/user-edit-form-type';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    imports: [TitleBarComponent, UserEditFormComponent, TranslateModule]
})
export class EditProfileComponent {

  public userInfo: UserInfoDTO = this.authService.getUserInfo();

  public userEditForm: UserEditFormGroup = this.fb.group<UserEditFormType>({
    userId: this.fb.control<string>(this.userInfo.userId),
    firstname: this.fb.control<string>(this.userInfo.firstname, [Validators.required]),
    lastname: this.fb.control<string>(this.userInfo.lastname, [Validators.required]),
    userName: this.fb.control<string>({ value: this.userInfo.userName, disabled: true }),
    language: this.fb.control<string>(this.userInfo.language, [Validators.required]),
    email: this.fb.control<string>({ value: this.userInfo.email, disabled: true }, [Validators.required, Validators.email]),
    phoneNumber: this.fb.control<string>(this.userInfo.phoneNumber, [CustomValidatorsFactory.createPhoneValidator()]),
    enabled: this.fb.control<boolean>(this.userInfo.enabled ?? false),
    validated: this.fb.control<boolean>(this.userInfo.enabled ?? false),
    fullAddress: this.fb.control<string>(this.userInfo.fullAddress),
    addressCompletionId: this.fb.control<string>({ value: null, disabled: true }),
    addressAutocompleteSessionToken: this.fb.control<string>({ value: null, disabled: true }),
    addressCoordinates: this.fb.control<string>({ value: this.userInfo.addressCoordinates, disabled: true }),
    client: this.fb.control(this.userInfo.client),
    companyId: this.fb.control<number>(this.userInfo.companyId),
    accessCode: this.fb.control<string>(this.userInfo.accessCode),
    accessCodeValidUntil: this.fb.control<Date>(this.userInfo.accessCodeValidUntil ? this.userInfo.accessCodeValidUntil.toJSDate() : null, [CustomValidatorsFactory.accessCodeDateValidator()]),
    accessCodeGeneratedOn: this.fb.control<Date>(this.userInfo.accessCodeGeneratedOn ? this.userInfo.accessCodeGeneratedOn.toJSDate() : null),
    accessCodeUsedOn: this.fb.control<Date>(this.userInfo.accessCodeUsedOn ? this.userInfo.accessCodeUsedOn.toJSDate() : null),
    role: this.fb.control<Role>(!!this.userInfo.roles?.length ? this.userInfo.roles[0] : null, [Validators.required]),
    controlPlates: this.fb.control(this.userInfo.controlPlates?.length ? this.userInfo.controlPlates : []),
    linkedParkers: this.fb.control(this.userInfo.linkedParkers?.length ? this.userInfo.linkedParkers : [])
  });

  constructor(private authService: AuthService,
              private editProfileService: EditProfileService,
              private toastService: ToastService,
              private router: Router,
              private fb: FormBuilder) {
  }

  public save(): void {
    if (this.userEditForm.valid) {
      this.editProfileService.save(this.userEditForm).subscribe({
        next: (res) => {
        this.router.navigate([homeRoute]);
      }, error: error => {
        this.toastService.showApiExeption(error,
          'i18n.core.messages.user-edit.title',
          'i18n.core.messages.user-edit.message');
      }});
    }
  }
}
